/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { footerPayoutDetailConfig } from '../../config/footer.config';

export interface IFooterPayoutDetailContentPluginMethods
  extends IPluginMethodMap {
  getFooterPayoutDetailContentSync(args?: any): any;
}

export class FooterPayoutDetailContentPlugin implements IAgentPlugin {
  readonly methods: IFooterPayoutDetailContentPluginMethods;

  constructor() {
    this.methods = {
      getFooterPayoutDetailContentSync:
        this.getFooterPayoutDetailContentSync.bind(this),
    };
  }

  getFooterPayoutDetailContentSync(args?: any) {
    return {
      footer: footerPayoutDetailConfig,
    };
  }
}
